import MuiList from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { ListItemText } from "components/ListItemText";

export function ContentList({
  listContent,
}: {
  listContent: readonly React.ReactNode[];
}) {
  return (
    <MuiList dense>
      {listContent.map((content, index) => {
        return (
          <ListItem key={index}>
            <ListItemText>{content}</ListItemText>
          </ListItem>
        );
      })}
    </MuiList>
  );
}
